import {
  BellAlertIcon,
  BuildingOffice2Icon,
  CalendarDaysIcon,
  CreditCardIcon,
  MapIcon,
  NewspaperIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  SparklesIcon,
  StarIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/solid";

const testimonials = [
  [
    {
      content:
        "Guests can make specific food or drink orders to their room, start a tab or request information about menus",
      category: "Food & drink",
      description: "Make food & drink orders instantly",
      icon: (
        <ShoppingCartIcon className="h-10 w-10 text-success object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Properties can create audio & visual campaigns to promote merchandise and offers to guests to boost revenue",
      category: "Merchandise",
      description: "Boost revenue for merchandise sales",
      icon: (
        <ShoppingBagIcon className="h-10 w-10 text-danger object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Notify guests of their daily agenda or bookings and let them know of any upcoming activities that may take their interest",
      category: "Schedule",
      description: "Personalised agenda on demand",
      icon: (
        <CalendarDaysIcon className="h-10 w-10 text-primary object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Guests and staff can request cleaning with a simple voice command or ask when the cleaner will be coming next",
      category: "Cleaning",
      description: "Empower guests to log cleaning requests",
      icon: (
        <SparklesIcon className="h-10 w-10 text-warning object-cover group-hover:text-white" />
      ),
    },
  ],
  [
    {
      content:
        "If something needs fixing, guests and staff can log a request and the maintenance team will be notified immediately",
      category: "Maintenance",
      description: "Increase efficiency of maintenance requests",
      icon: (
        <WrenchScrewdriverIcon className="h-10 w-10 text-light object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Guests and staff can receive location specific instructions to navigate their way around your property",
      category: "Orientation",
      description: "Access personalised navigation instructions",
      icon: (
        <MapIcon className="h-10 w-10 text-info object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Guests can listen to local stories, learn facts & trivia or ask questions about the local area and amenities with ease",
      category: "Local information",
      description: "Maintain a library of useful information",
      icon: (
        <MapIcon className="h-10 w-10 text-success object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Guests and staff can listen to music, the radio, the news or get a quick breakdown of the daily bulletins at any time",
      category: "Entertainment",
      description: "Stimulating content on demand",
      icon: (
        <NewspaperIcon className="h-10 w-10 text-danger object-cover group-hover:text-white" />
      ),
    },
  ],
  [
    {
      content:
        "Guests can settle outstanding bills and pay for specific items instantly, providing a seamless payment experience",
      category: "Payments",
      description: "Seamless Pay-by-Voice experience",
      icon: (
        <CreditCardIcon className="h-10 w-10 text-primary object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Guests can request information about services such as opening times and their location as well as book appointments",
      category: "Services",
      description: "Keep guests informed on available services",
      icon: (
        <StarIcon className="h-10 w-10 text-warning object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Guests can pay the balance of their stay and check out instantly, allowing for a streamlined stay and exit from the property",
      category: "Check out",
      description: "Guests can complete their stay with ease",
      icon: (
        <BuildingOffice2Icon className="h-10 w-10 text-danger object-cover group-hover:text-white" />
      ),
    },
    {
      content:
        "Staff and administrators can instantly send messages to guests and guests can instantly contact teams through a voice call",
      category: "Notifications",
      description: "24 hour communication channel",
      icon: (
        <BellAlertIcon className="h-10 w-10 text-light object-cover group-hover:text-white" />
      ),
    },
  ],
];

export default function UseCases() {
  return (
    <section
      id="reviews"
      aria-label="Use cases for audico Health"
      className="relative py-32 sm:pb-48"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl md:text-center">
          <h2 className="font-display tracking-tight text-white text-3xl sm:text-4xl md:text-5xl gotham-bold">
            Use cases
          </h2>
          <p className="mt-4 text-lg tracking-tight text-light">
            See how our multi-modal platform is being used by arenas, hotels and
            hospitality venues.
          </p>
        </div>
        <ul className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:gap-8 lg:mt-20 lg:max-w-none lg:grid-cols-3">
          {testimonials.map((column, columnIndex) => (
            <li key={columnIndex}>
              <ul className="flex flex-col gap-y-6 sm:gap-y-8">
                {column.map((testimonial, testimonialIndex) => (
                  <li key={testimonialIndex}>
                    <figure className="group relative rounded-2xl bg-light/10 hover:bg-info drop-shadow p-6">
                      {/* <QuoteIcon className="absolute left-6 top-6 fill-midnight group-hover:fill-info" /> */}
                      <blockquote className="relative">
                        <p className="text-lg tracking-tight text-secondary group-hover:text-white">
                          {testimonial.content}
                        </p>
                      </blockquote>
                      <figcaption className="relative mt-6 flex items-center justify-between border-t border-secondary group-hover:border-white pt-6">
                        <div className="pr-2">
                          <div className="font-display text-base text-secondary group-hover:text-white gotham-bold">
                            {testimonial.category}
                          </div>
                          <div className="mt-1 text-sm text-secondary group-hover:text-white">
                            {testimonial.description}
                          </div>
                        </div>
                        <div>{testimonial.icon}</div>
                      </figcaption>
                    </figure>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>

      {/* <div className="mt-16 flex justify-center">
        <a href="#!" className="bg-info px-8 py-3 leading-6 text-white drop-shadow rounded-full text-xl font-bold hover:bg-fuchsia-800">
          Read our customer success stories here →
        </a>
      </div> */}
    </section>
  );
}
